export default __webpack_public_path__ + "static/media/handlebars.19f6ed39.svg";